import React from "react";

export default function SquareBrackets() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18}>
            <path
                style={{
                    stroke: "none",
                    fillRule: "nonzero",
                    fill: "#000",
                    fillOpacity: 1,
                }}
                d="M3.656 3.656v10.688h1.969c.465 0 .844.379.844.844a.845.845 0 0 1-.844.843H2.812a.845.845 0 0 1-.843-.843V2.812c0-.464.379-.843.843-.843h2.813c.465 0 .844.379.844.843a.845.845 0 0 1-.844.844ZM15.187 1.97h-2.812a.845.845 0 0 0-.844.843c0 .465.38.844.844.844h1.969v10.688h-1.969a.845.845 0 0 0-.844.844c0 .464.38.843.844.843h2.813a.845.845 0 0 0 .843-.843V2.812a.845.845 0 0 0-.843-.843Zm0 0"
            />
        </svg>
    );
}